import { notificationRepository } from '../../../repository/notification.repository';

const getNextQuery = (params, list, has_more) => {
    const lastId = list.length > 0 ? list[list.length - 1].id : 0;
    const nextQuery = { ...params };
    nextQuery.starting_after = lastId;
    nextQuery.has_more = has_more;
    return nextQuery;
  };
  
  const mergeList = (previousList, newList) => {
    const list = previousList ? [...previousList, ...newList] : newList;
    
    return list;
  };  

const getNotifications = (params, previousNotificationList) => {
  return new Promise((resolve, reject) => {
    notificationRepository
      .getNotifications(params)
      .then((res) => {
        // console.log(res)
        const notificationList = mergeList(previousNotificationList, res.data);
        const query = getNextQuery(params, notificationList, res.has_more);
        const data = {
            notificationList,
            query,
        };
        resolve(data);
      })
      .catch((err) => {
        // console.log(err);
        reject(err);
      });
  });
};

export const notificationViewModel = {
    getNotifications
}